import React, { useState, useContext } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import moment from "moment";
import { observer } from "mobx-react-lite";
import Timeline from "@mui/lab/Timeline";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DescriptionIcon from "@mui/icons-material/Description";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import { faBarcode, faEllipsisV } from "@fortawesome/free-solid-svg-icons";

import { EnumCatalogosEncabezado, EnumStatusShipment } from "../Enumerables";
import { StatusShipment } from "../../app/util/constants";

import { RootStoreContext } from "../../app/store/root";
import { useEffect } from "react";
import { toJS } from "mobx";

const ActualizacionesTracker = (props) => {
  const { tipo } = props;
  const rootStore = useContext(RootStoreContext);
  const { entity } = rootStore.shipmentStore;
  const { entity: entityEmbarque } = rootStore.embarqueStore;
  const { getValoresCatalogo } = rootStore.catalogosStore;

  const [estatusEmbarque, setEstatusEmbarque] = useState([])
  
  useEffect(() => {
    if(tipo == 'embarques'){
      loadCatalogoEmbarque()
    }
  }, [])

  const loadCatalogoEmbarque = async () => {
    let estatus = await getValoresCatalogo(EnumCatalogosEncabezado.EstatusEmbarque)
    if (estatus != null) setEstatusEmbarque(estatus)    
  }

  /* Methods */
  const IconShipmentStatus = ({ idStatus }) => (
    <>
      {idStatus === EnumStatusShipment.Creado ? (
        <ExpandMoreIcon />
      ) : idStatus === EnumStatusShipment.Recibido ? (
        <ExpandMoreIcon />
      ) : idStatus === EnumStatusShipment.Documentado ? (
        <ExpandMoreIcon />
      ) : idStatus === EnumStatusShipment.En_Transito ? (
        <ExpandMoreIcon />
      ) : (
        <ExpandMoreIcon />
      )}
    </>
  );
  /* End Methods */

  return (
    <Box>
      <Accordion elevation={1}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="Actualizaciones-content"
          id="Actualizaciones-header"
        >
          <Typography variant="h6" color={"primary.main"}>
            Actualizaciones
          </Typography>
        </AccordionSummary>

        <AccordionDetails>
          {tipo === "embarques" && (
            <Timeline>
              {entityEmbarque?.movimientos &&
                entityEmbarque?.movimientos
                  .map((x, index) => (
                    <TimelineItem key={index}>
                      <TimelineOppositeContent
                        sx={{ m: "auto 0" }}
                        align="right"
                        variant="body2"
                      >
                        {x?.fechaMovimiento
                          ? moment(new Date(x?.fechaMovimiento)).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )
                          : ""}
                      </TimelineOppositeContent>

                      <TimelineSeparator>
                        <TimelineConnector />

                        <TimelineDot color="success">
                          <FontAwesomeIcon icon={faBarcode} />
                        </TimelineDot>

                        <TimelineConnector />
                      </TimelineSeparator>

                      <TimelineContent sx={{ py: "12px", px: 2 }}>
                        <Accordion elevation={0}>
                          <AccordionSummary
                            expandIcon={
                              <IconShipmentStatus idStatus={x?.idEstatus} />
                            }
                            aria-controls="track-content"
                            id="track-header"
                            sx={{ padding: 0 }}
                          >
                            <Typography variant="labelBold">
                              {
                                estatusEmbarque.find((s) => s.id == x?.idEstatus)?.valor ?? ""
                              }
                            </Typography>
                          </AccordionSummary>
                          {x?.mostrarMoviento && (
                            <AccordionDetails>
                              <Typography variant="labelBold">
                                Detalles del envío
                              </Typography>
                              <Typography>{x?.comentarios}</Typography>
                            </AccordionDetails>
                          )}
                        </Accordion>
                      </TimelineContent>
                    </TimelineItem>
                  ))}
            </Timeline>
          )}

          {tipo === "envios" && (
            <Timeline>
              {entity?.actualizaciones &&
                entity?.actualizaciones
                  .slice()
                  .reverse()
                  .map((x, index) => (
                    <TimelineItem key={index}>
                      <TimelineOppositeContent
                        sx={{ m: "auto 0" }}
                        align="right"
                        variant="body2"
                      >
                        {x?.fechaMovimiento
                          ? moment(new Date(x?.fechaMovimiento)).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )
                          : ""}
                      </TimelineOppositeContent>

                      <TimelineSeparator>
                        <TimelineConnector />

                        <TimelineDot color="success">
                          <FontAwesomeIcon icon={faBarcode} />
                        </TimelineDot>

                        <TimelineConnector />
                      </TimelineSeparator>

                      <TimelineContent sx={{ py: "12px", px: 2 }}>
                        <Accordion elevation={0}>
                          <AccordionSummary
                            expandIcon={
                              <IconShipmentStatus idStatus={x?.idEstatus} />
                            }
                            aria-controls="track-content"
                            id="track-header"
                            sx={{ padding: 0 }}
                          >
                            <Typography variant="labelBold">
                              {
                                StatusShipment.find(
                                  (s) =>
                                    Object.entries(s)[0][1] === x?.idEstatus
                                )?.Label
                              }
                            </Typography>
                          </AccordionSummary>

                          {x?.mostrarMoviento && (
                            <AccordionDetails>
                              <Typography variant="labelBold">
                                Detalles del envío
                              </Typography>
                              <Typography>{x?.comentarios}</Typography>
                            </AccordionDetails>
                          )}
                        </Accordion>
                      </TimelineContent>
                    </TimelineItem>
                  ))}
            </Timeline>
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default observer(ActualizacionesTracker);
